import React, { useEffect, useMemo } from "react";
import {
  BootstrapTable,
  TableHeaderColumn,
  ClearSearchButton,
} from "react-bootstrap-table";
import CatalogueCoordonnateurTableSkeleton from "./CatalogueCoordonnateurTableSkeleton";
import * as IconlyPack from "react-iconly";
import Pays from "../../../../images/NoImage.png";

import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import baseUrl from "../../../../Http/backend-base-url";
import Swal from "sweetalert2";
import countryList from "react-select-country-list";
import VoirCatalogueModal from "../../../Modals/Frontend/VoirCatalogueModal";
import University from "../../../../services/University";
import { fetchCatalogue } from "../../../../redux/catalogues/cataloguesAction";
import ModifierCatalogue from "../../../Modals/Coordonnateur/ModifierCatalogue";
import { useTranslation } from "react-i18next";

var CatalogueCoordonnateurTable = () => {
  const { t } = useTranslation();
  const country = useMemo(() => countryList().getData(), []);
  const catalogues = useSelector((state) => state.catalogues);
  const dispatch = useDispatch();

  var [ setIsPageLoading] = React.useState(true);

  var handleClearButtonClick = (onClick) => {
    console.log("This is my custom function for ClearSearchButton click event");
    onClick();
  };

  useEffect(() => {
    setTimeout(() => {
      // setIsPageLoading(false);
    }, 5000);
  }, [catalogues]);

  var createCustomClearButton = (onClick) => {
    return (
      <ClearSearchButton
        btnText="Effacer"
        btnContextual="btn-warning"
        className="my-custom-class"
        onClick={(e) => handleClearButtonClick(onClick)}
      />
    );
  };

  const options = {
    clearSearch: true,
    clearSearchBtn: createCustomClearButton,
    noDataText: t("noData"),
  };

  const onDelete = (id) => {
    // let token = window.sessionStorage.getItem("userToken");
    Swal.fire({
      // title: "Êtes vous sûr de vouloir archiver cet utilisateur?",
      title: t("warning_message_university"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: t("yes"),
      cancelButtonText: t("no"),
      showLoaderOnConfirm: true,
      preConfirm: () => {
        return University.onDeleteUniversity(id, config)
          .then(async (response) => {
            console.log("res", response);
            await dispatch(fetchCatalogue());
            return response;
          })
          .catch((error) => {
            console.log(error);
            Swal.showValidationMessage(`Request failed: ${error}`);
          });
      },
    }).then((result) => {
      if (result.isConfirmed) {
        console.log("res", result);
        Swal.fire({
          icon: "success",
          title: t("success"),
          showConfirmButton: false,
          timer: 2000,
        });
      }
    });
  };

  const config = {
    headers: {
      Authorization: `Bearer ${window.sessionStorage.getItem("userToken")}`,
    },
  };

  const photoFormatter = (cell, row) => {
    return (
      <div className="d-flex align-item-start ml-3">
        <img
          style={{ width: "50px", height: "50px", borderRadius: "5px" }}
          src={
            row?.logo && !row?.logo?.includes("default.png")
              ? baseUrl + row?.logo
              : Pays
          }
          alt="Default"
        />
        <div
          className="d-flex justify-content-center"
          style={{ flexDirection: "column" }}
        >
          <span className="name pl-3">{cell}</span>
          <strong className="entreprise ml-3">
            {row?.pays ? (
              <img
                src={`http://purecatamphetamine.github.io/country-flag-icons/3x2/${
                  country?.filter((val) => val?.label === row?.pays)[0]?.value
                }.svg`}
                alt=""
                style={{ width: "15px", height: "15px" }}
                className="img-drapeau mr-1"
              />
            ) : null}
            <span>{row.pays} </span>
          </strong>{" "}
        </div>
      </div>
    );
  };

  const filterTitle = (cell, row) => {
    return cell;
  };

  const actionFormatter = (cell, row) => {
    return (
      <div className="table-actions-btn-container">
        <button className="action-btn show-btn" title="Details">
          <IconlyPack.Show
            set="light"
            primaryColor="#C8C8C8"
            className="action-btn-icon action-show-icon"
            data-toggle="modal"
            data-target={`#VoirCatalogueModal${row?.id}`}
          />
        </button>
        <button className="action-btn edit-btn" title={t("edit")}>
          <IconlyPack.Edit
            set="light"
            primaryColor="#C8C8C8"
            className="action-btn-icon action-edit-icon"
            data-toggle="modal"
            data-target={`#ModifierCatalogueCoordonnateurModal${row?.id}`}
          />
        </button>
        <button className="action-btn delete-btn" title={t("delete")}>
          <IconlyPack.Delete
            set="light"
            primaryColor="#C8C8C8"
            className="action-btn-icon action-delete-icon"
            onClick={() => onDelete(row?.id)}
          />
        </button>

        <div
          className="modal fade"
          id={`VoirCatalogueModal${row?.id}`}
          tabIndex="-1"
          aria-labelledby="VoirCatalogueModalLabel"
          aria-hidden="true"
        >
          <VoirCatalogueModal item={row} />
        </div>

        <div
          className="modal fade"
          id={`ModifierCatalogueCoordonnateurModal${row?.id}`}
          tabIndex="-1"
          aria-labelledby="ModifierCatalogueCoordonnateurModalLabel"
          aria-hidden="true"
        >
          <ModifierCatalogue university={row} />
        </div>
      </div>
    );
  };

  return (
    <div className="child-table-container">
      <div className="table-body-container">
        <div className="row easypm-table-row m-t-50 m-b-50">
          <div className="col-md-12 easypm-table-col">
            {catalogues?.isLoading && <CatalogueCoordonnateurTableSkeleton />}
            {!catalogues?.isLoading && (
              <div className="table-container">
                <BootstrapTable
                  data={catalogues?.data}
                  tableContainerClass="table-responsive"
                  striped={true}
                  hover={true}
                  condensed={true}
                  multiColumnSort={2}
                  options={options}
                  pagination
                  search={false}
                  version="4"
                  bordered={false}
                >
                  <TableHeaderColumn
                    thStyle={{
                      fontWeight: 600,
                      fontSize: 16,
                      color: "#1A5C8C",
                    }}
                    tdStyle={{
                      fontWeight: 500,
                      fontSize: 14,
                      color: "rgba(0, 0, 0, 0.7)",
                    }}
                    dataField="id"
                    isKey={true}
                    hidden={true}
                  >
                    ID
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    thStyle={{
                      fontWeight: 600,
                      fontSize: 16,
                      color: "#1A5C8C",
                    }}
                    tdStyle={{
                      fontWeight: 500,
                      fontSize: 14,
                      color: "rgba(0, 0, 0, 0.7)",
                    }}
                    filter={{
                      type: "TextFilter",
                      style: { visibility: "hidden" },
                    }}
                    width="100"
                    dataField="id"
                  >
                    N°
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    thStyle={{
                      fontWeight: 600,
                      fontSize: 16,
                      color: "#1A5C8C",
                    }}
                    tdStyle={{
                      fontWeight: 500,
                      fontSize: 14,
                      color: "rgba(0, 0, 0, 0.7)",
                    }}
                    width="250"
                    filter={{ type: "TextFilter" }}
                    filterValue={filterTitle}
                    dataField="nom"
                    dataFormat={(cell, row) => photoFormatter(cell, row)}
                  >
                    {t("title")}
                  </TableHeaderColumn>

                  <TableHeaderColumn
                    thStyle={{
                      fontWeight: 600,
                      fontSize: 16,
                      color: "#1A5C8C",
                    }}
                    tdStyle={{
                      fontWeight: 500,
                      fontSize: 14,
                      color: "rgba(0, 0, 0, 0.7)",
                    }}
                    filter={{
                      type: "TextFilter",
                      style: { visibility: "hidden" },
                    }}
                    width="250"
                    dataField="created_at"
                    dataFormat={(cell, row) =>
                      moment(cell).format("DD MMMM YYYY")
                    }
                  >
                    {t("added_date")}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    thStyle={{
                      fontWeight: 600,
                      fontSize: 16,
                      color: "#1A5C8C",
                    }}
                    tdStyle={{
                      fontWeight: 500,
                      fontSize: 14,
                      color: "rgba(0, 0, 0, 0.7)",
                    }}
                    filter={{
                      type: "TextFilter",
                      style: { visibility: "hidden" },
                    }}
                    width="100"
                    dataField="id"
                    dataFormat={(cell, row) => actionFormatter(cell, row)}
                  >
                    Action
                  </TableHeaderColumn>
                </BootstrapTable>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CatalogueCoordonnateurTable;
